module.exports = __webpack_public_path__ + "img/product-placeholder.436378d8.png";